// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domino-app.help-cards > div {
  min-height: 100px;
  width: 40vh;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.domino-app.help-cards .domino {
  min-width: 90px;
  height: 40px;
  margin: 0px;

  border-radius: 8px;
  padding: 0px;
}

.domino-app.help-cards .some-domino {
  box-shadow: 5px 5px 7px #20677b;

  font-size: 15px;
  font-family: "Manrope";
  font-weight: bold;
}

.domino-app.help-cards .domino:disabled {
  cursor: auto;
}

.domino-app.help-cards .some-domino:disabled {
  background: white;
}

.rect-first-last-domino {
  height: 100%;
  width: 100%;
  background-color: yellow;
}

.rect-inside-domino-for-modal-window {
  position: relative;
  height: 100%;
  width: 2%;
  background-color: #20677b;

  margin-left: auto;
  margin-right: auto;
}

.text-first-half-domino-for-modal-window {
  text-align: right;
  padding: 5px;
}

.text-second-half-domino-for-modal-window {
  text-align: left;
  padding: 5px;
}

.place-domino-for-modal-window {
  min-width: 85px;
  min-height: 40px;
  background-color: #ededed;

  border-radius: 8px;
  border: 2px solid #cacaca;
}

.text-is-not-right-for-modal-window {
  margin-top: 12px;

  font-size: 15px;
  font-family: "Manrope";
  color: red;
}

.connect-elem-for-modal-window {
  position: relative;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  width: 40px;
  height: 40px;

  display: flex;
  align-content: space-evenly;
  justify-content: space-evenly;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Domino/styles/ModalWindow.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;;EAEX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,+BAA+B;;EAE/B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,yBAAyB;;EAEzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;;EAEzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;AAC/B","sourcesContent":[".domino-app.help-cards > div {\n  min-height: 100px;\n  width: 40vh;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n}\n\n.domino-app.help-cards .domino {\n  min-width: 90px;\n  height: 40px;\n  margin: 0px;\n\n  border-radius: 8px;\n  padding: 0px;\n}\n\n.domino-app.help-cards .some-domino {\n  box-shadow: 5px 5px 7px #20677b;\n\n  font-size: 15px;\n  font-family: \"Manrope\";\n  font-weight: bold;\n}\n\n.domino-app.help-cards .domino:disabled {\n  cursor: auto;\n}\n\n.domino-app.help-cards .some-domino:disabled {\n  background: white;\n}\n\n.rect-first-last-domino {\n  height: 100%;\n  width: 100%;\n  background-color: yellow;\n}\n\n.rect-inside-domino-for-modal-window {\n  position: relative;\n  height: 100%;\n  width: 2%;\n  background-color: #20677b;\n\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.text-first-half-domino-for-modal-window {\n  text-align: right;\n  padding: 5px;\n}\n\n.text-second-half-domino-for-modal-window {\n  text-align: left;\n  padding: 5px;\n}\n\n.place-domino-for-modal-window {\n  min-width: 85px;\n  min-height: 40px;\n  background-color: #ededed;\n\n  border-radius: 8px;\n  border: 2px solid #cacaca;\n}\n\n.text-is-not-right-for-modal-window {\n  margin-top: 12px;\n\n  font-size: 15px;\n  font-family: \"Manrope\";\n  color: red;\n}\n\n.connect-elem-for-modal-window {\n  position: relative;\n  margin-top: 5px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 40px;\n  height: 40px;\n\n  display: flex;\n  align-content: space-evenly;\n  justify-content: space-evenly;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
